import { List } from 'foundations-components/transitional/components/List';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import I18n from 'I18n';
import usageTracker from '../../../utils/usageTracker';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { RightIcon } from 'foundations-assets';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { useCallback } from 'react';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BreadcrumbWrapper = styled.span.withConfig({
  displayName: "PublicPageBreadcrumbs__BreadcrumbWrapper",
  componentId: "sc-1af6bhk-0"
})(["a{font-weight:normal;&:hover{text-decoration:underline;text-decoration-color:", ";}}"], ({
  theme
}) => theme.color['text-interactive-on-fill-hover']);
const PublicPageBreadcrumbs = ({
  entries
}) => {
  const handleTrackBreadcrumbItemClick = useCallback(href => () => {
    usageTracker.track('navInteraction', {
      action: 'breadcrumb-click',
      href
    });
  }, []);
  return /*#__PURE__*/_jsx("nav", {
    "aria-label": I18n.text('academyPublic.contentLandingPage.primaryDetails.breadcrumbs.ariaLabel'),
    children: /*#__PURE__*/_jsx(List, {
      inline: true,
      marginBlockEnd: "800",
      wrapChildren: true,
      children: entries.map(({
        name,
        href,
        to
      }, index) => {
        const textContent = /*#__PURE__*/_jsx(Text, {
          as: "span",
          color: "text-core-on-fill-default",
          children: name
        });
        return /*#__PURE__*/_jsxs(View, {
          as: "span",
          children: [index !== 0 && /*#__PURE__*/_jsx(IconHolder, {
            color: "icon-core-on-fill-default",
            icon: RightIcon,
            marginInlineEnd: "100",
            padding: "0",
            size: "200"
          }), href || to ?
          /*#__PURE__*/
          // @bend-expect trellis-tokenized
          _jsx(BreadcrumbWrapper, {
            children: href ? /*#__PURE__*/_jsx(Link, {
              href: href,
              onClick: handleTrackBreadcrumbItemClick(href),
              underline: false,
              children: textContent
            }) : /*#__PURE__*/_jsx(RouterLink, {
              onClick: handleTrackBreadcrumbItemClick(to),
              to: to,
              underline: false,
              use: "unstyled",
              children: textContent
            })
          }) : textContent]
        }, index);
      })
    })
  });
};
export default PublicPageBreadcrumbs;